export default __webpack_public_path__ + "static/media/active_project_icon.0c10075a.svg";